const content = {
    walmart_order_history: {
        en: {
            summary_no_video_html: `
            <h2>Before you start</h2> 
            <p>It's important you complete each step, or we won't be able to process your payment! Our
              instructions are easy to follow.</p>`,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: `
                <p>Install the Measure Extension.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: `
                <p>Go to Walmart.com, sign in, and go to purchase history</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: `
                <p>Launch the Measure Extension.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `
                <p><b>Click on Collect in Extension.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '5',
                    description_html: `
                <p> Upload the file created by Measure Extension.</p>`
                },
            ]
        }
    }
}

export const walmartDataTypes = {
    walmart_order_history: {
        data_type: 'walmart_order_history',
        data_type_description: 'Walmart Orders',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/walmart/logo2.png',
        capture_type: 'file',
        use_in_app_screen_recorder: false,
        require_consent: false,
        generic: {
        },
        file_source: 'localStorage',
        instructions_type: 'component'
    },
}